import { createAction } from '@reduxjs/toolkit';
import { Asset, AssetDetails } from '../../api';
import { FinderSelected, FinderShape } from './model';

export const assetSelected = createAction<FinderSelected, 'al/finder/assetSelected'>(
  'al/finder/assetSelected',
);

// force: перечитать список из сети, игнорируя кэш локации. Один и тот же экшен служит и
// навигацией (кэш желателен — переход мгновенный), и «перечитай после мутации» (upload,
// delete — кэш обязан быть выброшен, иначе на экране остаётся снапшот до изменения).
export const loadAssetsRequested = createAction<
  { force?: boolean } | undefined,
  'al/finder/loadAssetsRequested'
>('al/finder/loadAssetsRequested');

export const nextPageRequested = createAction<void, 'al/finder/nextPageRequested'>(
  'al/finder/nextPageRequested',
);

export const assetClicked = createAction<
  { id: Asset['id']; shiftKey: boolean; ctrlKey: boolean },
  'al/finder/assetClicked'
>('al/finder/assetClicked');

export const containerWidthChanged = createAction<
  { width: number },
  'al/finder/containerWidthChanged'
>('al/finder/containerWidthChanged');

export const detailsRequested = createAction<void, 'al/finder/detailsRequested'>(
  'al/finder/detailsRequested',
);

export const detailsChanged = createAction<
  { asset: AssetDetails | undefined; error: FinderShape['details']['error'] },
  'al/finder/detailsChanged'
>('al/finder/detailsChanged');

export const setDetailsLoading = createAction<{ loading: boolean }, 'al/finder/setDetailsLoading'>(
  'al/finder/setDetailsLoading',
);

export const setDetailsVisible = createAction<{ visible: boolean }, 'al/finder/setDetailsVisible'>(
  'al/finder/setDetailsVisible',
);

export const navigationKeyPressed = createAction<
  { key: string; shiftKey: boolean; ctrlKey: boolean },
  'al/finder/navigationKeyPressed'
>('al/finder/navigationKeyPressed');

export const slotHeightChanged = createAction<{ slotHeight: number }>(
  'al/finder/slotHeightChanged',
);

export const setSlotDragging = createAction<{ slotDragging: boolean }>('al/finder/setSlotDragging');

export const originalViewEnabled = createAction('al/finder/originalViewEnabled');
